﻿import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import definitions from '../../../Style/LfStyleDefinitions';
import {iconCode, mediaQuery, clearFix} from '../../../Style/cssHelpers';
import {connect} from 'react-redux';
import {pageCurrentStepAction} from '../../../State/actions';
import {
    retirementGuideUpdateFormDataAction,
    retirementGuideUpdateChartAction
} from '../State/actions';

import Form from '../../../../vendor/react-validation/components/form';
import ValidationButton from '../../../Forms/Components/ValidationButton';
import BackButton from '../Components/BackButton';
import { motion } from 'framer-motion';
import getFormValues from '../../../Forms/getFormValues';
import {scrollToTop} from '../../../Utils/scroll';
import throttle from '../../../Utils/throttle';

export class GuideFormBase extends React.Component {
    static get propTypes() {
        return {
            scrollToTopOnContinue: PropTypes.func,
            submitOnStep: PropTypes.number
        }
    }

    constructor(props) {
        super(props);

        this.form = null;
        this.validationTimer = null;
        this.validationDelay = 1000;

        this.state = {
            feedbackPageVisible: false
        }
    }

    handleFormChange = throttle((e) => {
        const formValues = getFormValues(this.form);
        this.props.updateFormData(formValues);
    }, 200);

    submitSection(e) {
        e.preventDefault();

        if (this.props.currentStep == this.props.submitOnStep - 1) {
            this.props.updateChart();
        }

        if(typeof this.feedbackPage !== 'undefined'
            && !this.state.feedbackPageVisible
            && this.shouldShowFeedbackPage())
        {
            this.setState({
                feedbackPageVisible: true
            });

            return;
        }

        if (this.props.scrollToTopOnContinue()
            || this.props.currentStep == this.props.submitOnStep - 1)
        {
            scrollToTop(350).then(() => {
                this.props.setCurrentStep(this.props.currentStep + 1);
            });
        } else {
            this.props.setCurrentStep(this.props.currentStep + 1);
        }
    }

    previousSection(e) {
        e.preventDefault();

        if (this.props.scrollToTopOnContinue()) {
            scrollToTop(350).then(() => {
                this.props.setCurrentStep(this.props.currentStep - 1);
            });
        } else {
            this.props.setCurrentStep(this.props.currentStep - 1);
        }
    }

    startValidationTimer() {
        if (!this.validationTimer) {
            this.validationTimer = setTimeout(this.form.validateAll, this.validationDelay);
        }
    }

    cancelValidationTimer() {
        if (this.validationTimer) {
            clearTimeout(this.validationTimer);
        }
    }
    closeFeedbackPage() {
        this.setState({ feedbackPageVisible: false });
    }

    navigationButtons = (props) => {
        const ButtonWrapper = (props.mobileOnly ? ButtonWrapperMobile : ButtonWrapperDesktop);

        return (
            <ButtonWrapper>
                {this.props.currentStep > 0 &&
                    <BackButton onClick={e => this.previousSection(e)}>
                        Tillbaka
                    </BackButton>
                }

                <ValidationButton
                    topMargin="0"
                    onMouseEnter={e => this.startValidationTimer(e)}
                    onMouseLeave={e => this.cancelValidationTimer(e)}
                >
                    Gå vidare
                </ValidationButton>
            </ButtonWrapper>
        );
    }

    stepFormWrapper = (props) => {
        const FeedbackPage = this.feedbackPage;

        return (
            <div>
                <GuideFormWrapper>
                    {!this.state.feedbackPageVisible &&
                        <Form
                            ref={el => { this.form = el; }}
                            onChange={e => this.handleFormChange(e)}
                            onSubmit={e => this.submitSection(e)}
                        >
                            <h3>{`${this.props.currentStep + 1}. ${props.heading}`}</h3>

                            {props.children}
                        </Form>
                    }

                    {this.state.feedbackPageVisible &&
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 0.5 }}
                        >
                            <FeedbackPageWrapper>
                                <FeedbackPage />
                                <BackButton onClick={e => this.closeFeedbackPage(e)}>
                                    Tillbaka
                                </BackButton>
                                <button onClick={e => this.submitSection(e)}>
                                    Nästa fråga
                                </button>
                            </FeedbackPageWrapper>
                        </motion.div>
                    }
                </GuideFormWrapper>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        currentStep: state.pageCurrentStep,
        formData: state.retirementGuideFormData.formData
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentStep: (step) => dispatch(pageCurrentStepAction(step)),
        updateFormData: (data) => dispatch(retirementGuideUpdateFormDataAction((data))),
        updateChart: () => dispatch(retirementGuideUpdateChartAction())
    };
};

export const connectForm = (formClass) => connect(mapStateToProps, mapDispatchToProps)(formClass);

// styles

const GuideFormWrapper = styled.div`
    display: block;
    margin-bottom: 5px;

    h3, h4, h5 {
        font-size: 28px;
        margin-top: 20px;
        margin-bottom: 15px;


    ${mediaQuery.small(`
        font-size: 20px;
    `)};
    }

    ${mediaQuery.small(`
        margin-top: 20px;
        margin-bottom: 65px;
    `)};
`;

const FeedbackPageWrapper = styled.div`
    max-width: 800px;
    display: block;
    margin: 0 auto;

    img {
        width: 300px;
        height: auto;

        margin-top: 20px;
        margin-bottom: 20px;
    }

    button:not([class^="BackButton"]) {
        margin-top: 15px; 
        padding: 10px 20px 10px 20px;
        ${mediaQuery.large(`
            padding: 12px 15px 12px 15px;
        `)}

        font-family: ${definitions.fonts.heading};
        font-size: 18px;
        ${mediaQuery.large(`
            font-size: 16px;
        `)}

        font-weight: bold;
        color: white;

        background-color: ${definitions.colors.green};
        border-radius: 5px;

        &:after {
            color: white;
            padding-left: 20px;
            font-size: 14px;

            ${iconCode.arrowRight()};
        }
`;

const ButtonWrapperMobile = styled.div`
    position: relative;
    width: auto;
    height: auto;
    display: none;
    margin-top: 50px;

    ${mediaQuery.small(`
        margin-top: 20px;
        display: block;
    `)};
`;
const ButtonWrapperDesktop = styled.div`
    position: relative;
    width: auto;
    height: auto;
    display: block;
    margin-top: 50px;

    ${mediaQuery.small(`
        margin-top: 20px;
        display: none;
    `)};
`;
